(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/actiontypes.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/actiontypes.js');
"use strict";


const CART_SET_PRODUCT = 'cart.CART_SET_PRODUCT';
const CART_APPEND_PRODUCT = 'cart.CART_APPEND_PRODUCT';
const CART_REMOVE_PRODUCT_GROUP = 'cart.CART_REMOVE_PRODUCT_GROUP';
const CART_CLEAR = 'cart.CART_CLEAR';
const CART_SET_ANIMATION_COMPLETE = 'cart.CART_SET_ANIMATION_COMPLETE';
const CART_SET_ERROR = 'cart.CART_SET_ERROR';
const CART_CLEAR_ERROR = 'cart.CART_CLEAR_ERROR';
svs.tickets_giftshop.gift.giftform.cart.actiontypes = {
  CART_SET_PRODUCT,
  CART_APPEND_PRODUCT,
  CART_REMOVE_PRODUCT_GROUP,
  CART_CLEAR,
  CART_SET_ANIMATION_COMPLETE,
  CART_SET_ERROR,
  CART_CLEAR_ERROR
};

 })(window);